import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TPaymentViewData } from "../types/loans/payment_view";



export type TSaveReceipt = {
    utr: string,
    date: string,
    description: string,
}

export type TInitialState = {
    refId: number,
    paymentView: TPaymentViewData,
    saveReceipt: TSaveReceipt,
}

const initialState: TInitialState = {
    refId: 0,
    paymentView: {
        amount: 0,
        comments: "",
        disbAmt: 0,
        emiNos: [],
        firmName: "",
        images: [],
        loanAccNo: 0,
        loanId: "",
        mode: "",
        pfId: 0,
        platform: "",
        pmtDate: "",
        pmtReceiptDate: "",
        pmtStatus: "",
        receiptDesc: "",
        receivedTillDate: 0,
        repmtId: 0,
        tradeId: 0,
        utr: ""
    },
    saveReceipt: {
        utr: "",
        date: "",
        description: ""
    }
};

export const loanPaymentView = createSlice({
    name: "loanPaymentView",
    initialState: initialState,
    reducers: {
        setRefId: (state, action: PayloadAction<{
            refId: number,
        }>) => {
            state.refId = action.payload.refId;
        },
        setPaymentView: (state, action: PayloadAction<{
            paymentView: TPaymentViewData,
        }>) => {
            state.paymentView = action.payload.paymentView;
            state.saveReceipt = {
                ...initialState.saveReceipt,
                date: state.paymentView.pmtDate,
            };
        },
        updateSaveReceipt: (state, action: PayloadAction<{
            saveReceipt: TSaveReceipt,
        }>) => {
            state.saveReceipt = action.payload.saveReceipt;
        },
    },
});
export const {
    setRefId,
    setPaymentView,
    updateSaveReceipt,
} = loanPaymentView.actions;

export default loanPaymentView.reducer;
